/**
 * @module
 * @format
 */

import {COMPILE, SCOPE, UPGRADE} from '@acng/frontend-stargazer';
import {add} from '@acng/frontend-bounty/style/element.js';

/**
 * @import {Controller} from '@acng/frontend-stargazer';
 * @import {CreativeWork} from "../types";
 * @import {FeedItemData} from "./types"
 */

import {make} from '../core/service/env.js';
import {inject} from '../core/service/ng.js';
import {WeblogStore} from '../weblog/store.js';
import {get as getMovie} from '../moviePool/service/cache.js';
import {FEED_TYPE_MOVIE, FEED_TYPE_PICTURE, FEED_TYPE_WEBLOG} from './model.js';
import {ClickEventController, location} from 'nova';
import {now} from '@acng/frontend-bounty/std/date.js';

/**
 * @implements {Controller}
 */
class FeedItem {
  #type;
  #id;
  #date;

  /**
   * @param {FeedItemData} data
   */
  constructor({type, id, date}) {
    this.#type = type;
    this.#id = id;
    this.#date = date ? new Date(date) : null;
  }

  /**
   * 1. Load the referenced item.
   * 2. Set scope object.
   */
  async [COMPILE]() {
    const type = this.#type;
    const id = this.#id;
    const date = this.#date;

    const PictureSet = inject('PictureSet');
    const weblog = type == FEED_TYPE_WEBLOG ? await make(WeblogStore).get(id) : null;
    const movie = type == FEED_TYPE_MOVIE ? await getMovie(id) : null;
    const pictureSet = type == FEED_TYPE_PICTURE ? await PictureSet.get(id) : null;
    const gallery = movie ?? pictureSet;

    /**
     * @type {CreativeWork | null}
     */
    const feedItem = gallery ?? weblog;
    const dateCreated = date && now() - date.getTime() > 14 * 24 * 60 * 60 * 1000 ? null : date;

    ASSERT: if (!feedItem) {
      console.error('Nothing to show.', this);

      throw this;
    }

    this[SCOPE] = {
      weblog,
      movie,
      pictureSet,
      gallery,
      feedItem,
      dateCreated,
      click: new ClickEventController(() => (location.href = feedItem.url)),
    };
  }

  /**
   * 1. Add CSS class for the item type.
   * 2. Call the upgrade function of the item.
   *
   * @param {Element} element
   */
  [UPGRADE](element) {
    add(element, `feed-${this.#type}`);
    this[SCOPE]?.feedItem?.[UPGRADE](element);
  }
}

export {FeedItem};
